export default __webpack_public_path__ + "5fdd912ecc696d121b00297fec6ee85a.png";